<script>
export default {
  name: "customArticle",
  props: {
    fileList: {
      default: () => []
    },
    articleData: {
      default: () => {
        return {}
      }
    }
  }
}
</script>

<template>
  <div class="customArticle">
    <div v-if="articleData.articleType == 1">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in fileList" :key="index">
          <img style="width: 100%;" :src="item.displayFileUrl" alt="">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div v-else-if="articleData.articleType == 2">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in fileList" :key="index">
          <video controls style="width: 100%;height: 200px" :src="item.displayFileUrl"></video>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>